import React, { useState, useContext, useEffect } from "react";
import { Row, Col, Card, Carousel, Modal, Button } from "react-bootstrap";
import {
  FaPhone,
  FaBed,
  FaBath,
  FaRulerCombined,
  FaMapMarkerAlt,
  FaEnvelope,
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useParams, useNavigate } from "react-router-dom";
import { InfoContext } from "../providers/InfosContextProvider";
import { buildPublicAssetPath } from "../utils/publicAssetPath";

const Property = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalImageIndex, setModalImageIndex] = useState(0);
  const [currentCasa, setCurrentCasa] = useState(null);
  const [isCarouselPaused, setIsCarouselPaused] = useState(false);
  const [ok, setOk] = useState(false);
  const { houses, texts } = useContext(InfoContext);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (houses.length !== 0) {
      const casaEncontrada = houses.find((c) => c.id === parseInt(id));
      if (!casaEncontrada) {
        navigate("/", { replace: true });
      } else {
        setOk(true);
      }
    }
  }, [houses, id, navigate]);

  const casa = houses.find((c) => c.id === parseInt(id));

  useEffect(() => {
    const titleBase =
      casa?.localizacao || texts?.Property?.descricao || "Imóvel";
    document.title = `${titleBase} | Casas do Nabão`;
  }, [casa, texts]);

  const handleOpenModal = (index) => {
    setModalImageIndex(index);
    setCurrentCasa(casa);
    setIsCarouselPaused(true);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsCarouselPaused(false);
  };

  const handleMsg = (propertyId) => {
    navigate(`/contact?id=${propertyId}`);
  };

  return (
    <>
      {ok && casa && (
        <>
          <Header />
          <div className="property-detalhes-container">
            <Row>
              <Col xs={12} md={6} className="fixed-col">
                <Card className="property-detalhes-card">
                  <Carousel interval={isCarouselPaused ? null : 3000}>
                    {casa.images.map((imagem, index) => (
                      <Carousel.Item key={index}>
                        <div
                          className="carousel-image-container"
                          onClick={() => handleOpenModal(index)}
                        >
                          <img
                            className="d-block w-100"
                            src={buildPublicAssetPath(imagem)}
                            alt={`Slide ${index}`}
                            loading="lazy"
                          />
                        </div>
                      </Carousel.Item>
                    ))}
                  </Carousel>
                  <Card.Body>
                    <Card.Title>
                      <div className="property-detalhes-efficiency">
                        {casa.valor}
                        {casa.efficiency.map((efficiency, index) => (
                          <img
                            key={index}
                            src={buildPublicAssetPath(
                              `/assets/images/efficiency/${efficiency}_RGB.png`,
                            )}
                            alt={`Eficiência Energética ${efficiency}`}
                          />
                        ))}
                      </div>
                    </Card.Title>
                    <Row>
                      <Col className="text-center">
                        <span>
                          <FaMapMarkerAlt /> {casa.localizacao}
                        </span>
                      </Col>
                    </Row>
                    <Row className="justify-content-center align-items-end mt-2 mb-2">
                      {casa.area && (
                        <Col xs="auto">
                          <span className="text-dark">
                            <FaRulerCombined /> {casa.area}
                          </span>
                        </Col>
                      )}
                      {casa.bedrooms && (
                        <Col xs="auto">
                          <span className="text-dark">
                            <FaBed /> {casa.bedrooms}
                          </span>
                        </Col>
                      )}
                      {casa.bathrooms && (
                        <Col xs="auto">
                          <span className="text-dark">
                            <FaBath /> {casa.bathrooms}
                          </span>
                        </Col>
                      )}
                    </Row>
                    <div className="property-contacts">
                      <Row>
                        <Col xs={12}>
                          <div className="property-contact-row d-flex align-items-center justify-content-between flex-wrap mt-3">
                            <p className="mb-0">
                              <FaPhone className="me-2" />
                              <a
                                href={`tel:${casa.contacts.telefone
                                  .replace(/\+/g, "00")
                                  .replace(/\s/g, "")}`}
                              >
                                {casa.contacts.telefone}
                              </a>
                            </p>
                            <Button
                              className="btn-vender"
                              onClick={() => handleMsg(casa.id)}
                            >
                              <FaEnvelope className="me-2" />
                              {`${texts.Property.enviarMsg}`}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col xs={12} md={6} className="fixed-col">
                <div className="property-descricao">
                  <h3>{`${texts.Property.descricao}`}</h3>
                  <div className="property-description-text">
                    {casa.descricao.split(/\.\s+/).map((para, index, array) => (
                      <p key={index}>
                        {para}
                        {index < array.length - 1 ? "." : ""}
                      </p>
                    ))}
                  </div>

                  <div className="property-ref-ami-container mt-4 d-flex justify-content-end align-items-center">
                    <span className="ami-text me-3">AMI 23473</span>
                    <span className="ref-tag">
                      {`${texts.Property.ref}`} {casa.id}
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
            <Carousel
              activeIndex={modalImageIndex}
              onSelect={(selectedIndex) => setModalImageIndex(selectedIndex)}
            >
              {(currentCasa ?? casa).images.map((imagem, index) => (
                <Carousel.Item key={index}>
                  <div
                    className="carousel-image-container"
                    onClick={() => handleOpenModal(index)}
                  >
                    <img
                      className="d-block w-100 modal-image"
                      src={buildPublicAssetPath(imagem)}
                      alt={`Slide ${index}`}
                      loading="lazy"
                    />
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </Modal>

          <Footer />
        </>
      )}
    </>
  );
};

export default Property;
